// extracted by mini-css-extract-plugin
module.exports = {"main-contents":"Parser_main-contents__E7MSe"};